export function Carousel() {
    const setCarousel = ($container) => {

        // settings
        const largeBreakpoint = $container.data('large-breakpoint') ?? 1024;
        const mediumBreakpoint = $container.data('medium-breakpoint') ?? 768;
        const largeCount = $container.data('large') ?? 3;
        const mediumCount = $container.data('medium') ?? largeCount;
        const smallCount = $container.data('small') ?? largeCount;
        const autoplay = $container.data('autoplay');
        const autoplayTimeout = $container.data('autoplay-timeout') ?? 800;
        const lazyLoad = $container.data('lazyload');
        const nav = $container.data('nav');
        const largeStagePadding = $container.data('stagepadding-large');
        const mediumStagePadding = $container.data('stagepadding-medium');
        const smallStagePadding = $container.data('stagepadding-small');

        // responsive settings
        const responsiveSettings = {
            0: { items: 1, nav: false, slideBy: smallCount },
            320: { items: smallCount + smallStagePadding, nav: false, slideBy: smallCount }
        };
        responsiveSettings[mediumBreakpoint] = {
            items: mediumCount + mediumStagePadding,
            nav: false,
            slideBy: mediumCount

        };
        responsiveSettings[largeBreakpoint] = {
            items: largeCount + largeStagePadding,
            slideBy: largeCount
        };

        // set carousel
        $container.owlCarousel({
            loop: true,
            nav: nav,
            dots: false,
            autoplay: autoplay,
            autoplayTimeout: autoplayTimeout,
            lazyLoad: lazyLoad,
            responsive: responsiveSettings,
            rewind: false
        });
    }

    // Custom touch and drag carousel support for image variant
    const initImageCarousel = () => {
        // The carousel-init.js script handles this functionality
        // It's included directly in the Images.cshtml view
        console.log('Image carousel with touch/drag support initialized');
    }

    const init = () => {
        if ($('.owl-carousel').length) {
            $('.owl-carousel').each(function () {
                setCarousel($(this));
            });
        }
        
        // Initialize the image carousel (handled by separate script)
        initImageCarousel();
    }

    init();
}